import eventBus from '../../core/services/event-bus';

const CartPopup = () => {
  let isActive = false;
  let clearPopupTimeout;

  const removePopup = () => {
    clearTimeout(clearPopupTimeout);
    return new Promise(resolve => {
      const popup = document.getElementById('added-to-cart');
      popup?.classList.remove('active');
      setTimeout(() => {
        popup?.remove();
        isActive = false;
        resolve();
      }, 300);
    });
  };

  const addPopup = res => {
    clearTimeout(clearPopupTimeout);
    isActive = true;
    const item = res.detail.variant;
    const image = item.image.split('?')[0].replace('.jpg', '_x100.jpg').replace('.png', '_x100.png');

    const template = `
        <div id="added-to-cart">
          <div class="added-to-cart__image">
            <img src="${image}" alt="${item.title}"/>
          </div>
          <div class="added-to-cart__content text-end">
            <button class="added-to-cart__btn-close"><span class="icon-close"></span></button>
            <p class="added-to-cart__title">${item.title} has been added to your cart!<br><a href="/cart" class="btn btn-primary btn-small btn-view-cart">View Cart</a></p>  
          </div>
        </div>`;

    document.body.insertAdjacentHTML('beforeend', template);

    setTimeout(() => {
      document.getElementById('added-to-cart')?.classList.add('active');
    }, 300);

    // Uncomment if you want to automatically remove the popup after 3 seconds
    // clearPopupTimeout = setTimeout(removePopup, 3000);
  };

  // Remove on close click
  document.body.addEventListener('click', e => {
    if (e.target.closest('.added-to-cart__btn-close')) {
      removePopup();
    }
  });

  // Add on added to cart, but check for existing popup first
  eventBus.on(eventBus.types.AddedToCart, res => {
    if (isActive) {
      removePopup().then(() => addPopup(res));
    } else {
      addPopup(res);
    }
  });
};

export default CartPopup;